// extracted by mini-css-extract-plugin
export default {"gradientBottom":"settings_gradientBottom__4jQAk"};